<template>
  <article id="search-bar-container">
    <h2>Product Search</h2>
    <label for="search-input">
      <input
        id="search-input"
        name="search-input"
        type="text"
        :value="productQuery"
        placeholder="Search by product number or name"
        @input="$emit('input', $event.target.value)"
        ref="inputField"
      />
    </label>
  </article>
</template>

<script>
export default {
  name: "SearchBar",
  props: {
    productQuery: {
      type: String,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputField.focus();
    });
  },
};
</script>

<style lang="scss" scoped>
#search-bar-container {
  position: sticky;
  top: 0;
  z-index: 10;
  color: whitesmoke;
  padding: 1.5rem;

  h2 {
    font-family: "SlateStd";
    text-transform: capitalize;
    color: black;
    text-align: start;
    margin-bottom: 0.8rem;
    font-size: 1.1rem;
  }

  label {
    display: flex;
    position: relative;
    padding: 0;
    width: 100%;
    border-radius: 6px;
    margin-bottom: 0;
    input {
      border: none;
      width: 100%;
      height: calc(1.5em + 1.3rem + 2px);
      padding: 1rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      border-radius: 6px;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid $grey-light;
      border-radius: 6px;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

      &:focus {
        outline: none;
        border: 1px solid $placeholder;
      }
    }
  }
}
</style>